module.exports = __webpack_public_path__ + "static/media/project6.9dff175a.png";